// extracted by mini-css-extract-plugin
module.exports = {"time":"TimeLabel-module--time--UiJma"};